import { t } from 'i18next';
import { tss } from 'tss-react';

import InputNumber from 'components/desktop/_general/Input/InputNumber/Index';

interface IProps {
	scaledParts: number;
	setScaledParts: (scaledParts: number) => void;
}

const RecipeScaling = (props: IProps) => {
	const { classes } = useStyles();

	return (
		<div className={classes.container}>
			<InputNumber
				value={props.scaledParts}
				setValue={(value) => props.setScaledParts(value)}
				className="form-control-sm"
			/>
			<div style={{ minWidth: '50%' }}>
				{props.scaledParts} {t('recipe:PIECES')}
			</div>
		</div>
	);
};

export default RecipeScaling;

const useStyles = tss.create({
	container: {
		paddingTop: '22px',
		display: 'flex',
		gap: '15px',
	},
});
